<!-- eslint-disable eqeqeq -->
<template>
  <div>
    <!-- header menu -->
    <v-toolbar class="header-container">
      <!-- space between left menu and image logo -->
      <v-spacer></v-spacer>
      <!-- image logo and header environment -->
      <figure>
        <img :src="Logo" class="header-logo-image">
        <figcaption>
          <a class="header-sitename" href="/">
            Material Management Portal
            <span v-bind:class="{'lbl-red': isColorRed }" v-if="isColorRed === true">
              ({{ HeaderEnv }})
            </span>
          </a>
        </figcaption>
      </figure>
      <!-- space between image logo and search bar -->
      <v-spacer></v-spacer>
    </v-toolbar>
    <!-- extension menu -->
    <div v-if="screenWidth > 720" class="header-toolbar-extension" xs12>
      <v-menu
        v-for="(itemMain, index) in menuExtension"
        :key="itemMain.label"
        :close-on-content-click="true"
        transition="slide-x-transition"
        min-width="210px"
        offset-y
        lazy
        open-on-click
        :disabled="authLoading"
        nudge-left="32px"
        v-bind:style="getPadding(itemMain.label)"
      >
        <v-btn
          class="white--text header-toolbar-extension-btn font-gotham"
          slot="activator"
          :disabled="authLoading"
          @click="handleNavigateLevel1(itemMain.subGroup, itemMain.target)"
          flat
        >
          {{itemMain.label}}
        </v-btn>
        <div class="dropdown-menu show-xs">
          <div class="small-nav-container">
            <div class="small-nav small-nav-corp-links">
              <ul class="list-unstyled icon-list">
                <li
                  v-for="(itemSub) in menuExtension[index].subGroup"
                  :key="itemSub.label"
                  class="menu-hover"
                >
                  <v-menu
                    :close-on-content-click="true"
                    min-width="210px"
                    offset-x
                    allow-overflow
                    offset-overflow
                    lazy
                    nudge-top="6px"
                  >
                    <!-- open-on-hover -->
                    <v-btn slot="activator" @click="handleNavigate(itemSub.target)"
                      flat style="width: 210px"
                      class="header-toolbar-extension-btn font-gotham"
                    >
                      {{itemSub.label}}
                    </v-btn>
                    <div class="dropdown-menu show-xs">
                      <div class="small-nav-container">
                        <div class="small-nav small-nav-corp-links">
                          <v-btn
                            style="min-width: 210px"
                            flat
                            @click="handleNavigate(itemSub.target)"
                            class="header-toolbar-extension-btn font-gotham"
                          >
                            {{itemSub.label}}
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </v-menu>
    </div>
    <div class="menu-fepmt-footer" v-if="globalLoading">
      <v-progress-linear v-bind:id="'LoadingFEPMT'" :indeterminate="true" height="7" style="margin: 0px"></v-progress-linear>
    </div>
    <!-- left-menu form mode_1 : use v-navigation-drawer -->
    <v-navigation-drawer
      v-model="drawer"
      absolute
      hide-overlay
      v-bind:width='`${this.screenWidth <= 414 ? this.screenWidth : 350}`'
      v-if="this.screenWidth <= 720"
      class="navigation-drawer"
      height="85vh"
    >
      <v-list
        v-for="(item, index) in menuItems"
        :key="index"
      >
        <v-list-tile v-if="item.target.name === 'mainmenu'" class="list-tile-hover" @click="InitializeMenuItems()">
          <span class="glyphicon glyphicon-chevron-left"></span><v-list-tile-title v-text="item.label" class="font-gotham"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-else-if="item.canback && item.target.name !== 'mainmenu'" class="list-tile-hover" @click="handleShowNextLevel(item.target.name)">
          <span class="glyphicon glyphicon-chevron-left"></span><v-list-tile-title v-text="item.label" class="font-gotham"></v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-else class="list-tile-hover" @click="handleShowNextLevel(item.target.name)">
          <v-list-tile-title v-text="item.label" class="font-gotham"></v-list-tile-title><span v-if="item.cannext" class="glyphicon glyphicon-chevron-right"></span>
        </v-list-tile>
      </v-list>
      <v-list>
        <hr class="hr-line">
        <v-list-tile>
          <h3 class="quick-links">quick links</h3>
        </v-list-tile>
        <v-list-tile class="list-tile-hover">
          <a class="list-tile-hover-icon font-gotham" style="text-decoration: none;" href="https://chevron.sharepoint.com/sites/ASBUTHITProFEPMT/Lists/In%20App%20Useful%20Links/AllItems.aspx" target="blank">useful link</a>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Logo from '@assets/logo.png'
import { transcode } from 'buffer'
import constants from '@/services/constants'
export default {
  name: 'HeaderComponent',
  data () {
    return {
      Logo,
      menuJson: [],
      menuExtension: [],
      menuItems: [],
      screenWidth: null,
      toggleSearch: false,
      toggleAddMenu: false,
      drawer: false
    }
  },
  mounted () {
    this.screenWidth = document.documentElement.clientWidth
    window.addEventListener('resize', this.onResize)

    this.InitializeMenu()
    this.InitializeMenuExtension()
    this.GetPassport()

    if (this.screenWidth < 720) {
      this.HideExtensionMenu()
    }
  },
  methods: {
    // method 'onResize' use for set new clientWidth for do responsive screen
    onResize (event) {
      this.screenWidth = document.documentElement.clientWidth
      if (this.screenWidth <= 720) {
        this.HideExtensionMenu()
      } else {
        this.InitializeMenu()
      }
    },
    handleHoverItem (event) {
      console.log('--> hover on button', event)
    },
    // search function
    handleSearch (event) {
      console.log('HeaderComponent/handleSearch :', event)
    },
    handleNavigateLevel1 (childGroup, target) {
      if (childGroup.length === 0) {
        this.$router.push(target).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      } else {
        console.error('handleNavigateLevel1 has child')
      }
    },
    // navigate function work with left-menu
    handleNavigate (target) {
      // for case route filter
      const routeFilter = ['wh.filter']
      if (routeFilter.some(x => x === this.$router.currentRoute.name)) {
        console.log('--> is case special route')
        this.$router.push(target)
      } else {
        if (target.name === this.$router.currentRoute.name) {
          console.log('HeaderComponent/handleNavigate : Reload this page => ', this.$router.currentRoute.name)
          const url = window.location + `?q=${Date.now()}`
          console.log(url)
          this.$router.go(target)
        } else {
          this.$router.push(target)
        }
      }
    },
    // method 'InitializeMenu' use for set new item to menuJson
    InitializeMenu () {
      this.menuJson = []
      // this.menuJson.push({
      //   label: 'Platform',
      //   target: { name: 'location.platform' },
      //   orderNo: -1
      // })
      // this.menuJson.push({
      //   label: 'On shore location management',
      //   target: { name: 'location.onshore' },
      //   orderNo: -1
      // })
      // this.menuJson.push({
      //   label: 'Assigned Location',
      //   target: { name: 'location.assign' },
      //   orderNo: -1
      // })
      // this.menuJson.push({
      //   label: 'whatever1',
      //   target: { name: 'whatever1' },
      //   orderNo: -1
      // })
      // this.menuJson.push({
      //   label: 'whatever2',
      //   target: { name: 'whatever2' },
      //   orderNo: -1
      // })
      this.toggleAddMenu = false
      this.drawer = false
    },
    InitializeMenuExtension () {
      this.menuExtension = []
      this.menuExtension = [...this.$store.getters.menuList.filter(o => !o.hideMenu)]
      // this.menuExtension.push({
      //   label: 'RMR',
      //   target: { name: 'rmr.index' },
      //   subGroup: []
      // })
      // this.menuExtension.push({
      //   label: 'Receive Material',
      //   target: { name: 'wh.index' },
      //   subGroup: [
      //     {
      //       label: "Surplus",
      //       target: {
      //         name: "wh.filter" ,
      //         params: {
      //           returntype: constants.RETURN_TYPE.SURPLUS
      //         }
      //       }
      //     },
      //     {
      //       label: "Disposal",
      //       target: {
      //         name: "wh.filter" ,
      //         params: {
      //           returntype: constants.RETURN_TYPE.DISPOSAL
      //         }
      //       }
      //     },
      //     {
      //       label: "Repair/Return",
      //       target: {
      //         name: "wh.filter" ,
      //         params: {
      //           returntype: constants.RETURN_TYPE.REPAIR_RETURN
      //         }
      //       }
      //     },
      //     {
      //       label: "Courtesy",
      //       target: {
      //         name: "wh.filter" ,
      //         params: {
      //           returntype: constants.RETURN_TYPE.COURTESY
      //         }
      //       }
      //     }
      //   ]
      // })
      // this.menuExtension.push({
      //   label: 'Disposal Material',
      //   target: { name: 'material.index' },
      //   subGroup: []
      // })
      // this.menuExtension.push({
      //   label: 'Master',
      //   target: { name: 'master' },
      //   subGroup: [
      //     {
      //       label: 'Onshore Location',
      //       target: { name: 'location.onshore' }
      //     },
      //     {
      //       label: 'Platform',
      //       target: { name: 'location.platform' }
      //     },
      //     {
      //       label: 'Assigned Location',
      //       target: { name: 'location.assign' }
      //     },
      //     {
      //       label: 'Company',
      //       target: { name: 'location.company' }
      //     },
      //     {
      //       label: 'Field',
      //       target: { name: 'location.field' }
      //     },
      //     {
      //       label: 'Partner Share',
      //       target: { name: 'partner.share' }
      //     },
      //     {
      //       label: 'Material Type',
      //       target: { name: 'materialtype.index' }
      //     },
      //     {
      //       label: 'Justification',
      //       target: { name: 'justification.index' }
      //     }
      //   ],
      // })
      // this.menuExtension.push({
      //   label: 'Admin',
      //   target: { name: 'admin' },
      //   subGroup: [
      //     {
      //       label: 'User Management',
      //       target: { name: 'user.management' }
      //     },
      //     {
      //       label: 'DOA Approval',
      //       target: { name: 'doaapproval.index' }
      //     },
      //     {
      //       label: 'Audit Log',
      //       target: { name: 'auditlog.index' }
      //     },
      //   ]
      // })
    },
    InitializeMenuItems () {
      this.menuItems = []
      // add item to menuItems
      this.menuItems.push({
        label: 'RMR',
        target: { name: 'rmr.index' },
        canback: false,
        cannext: false
      })
      this.menuItems.push({
        label: 'RMR Warehouse',
        target: { name: 'b' },
        canback: false,
        cannext: false
      })
      this.menuItems.push({
        label: 'c',
        target: { name: 'c' },
        canback: false,
        cannext: true
      })
      this.menuItems.push({
        label: 'd',
        target: { name: 'd' },
        canback: false,
        cannext: false
      })
    },
    handleShowNextLevel (targetName) {
      if (targetName === 'a') {
        this.menuItems = []
        this.menuItems.push({
          label: 'back to mainmenu',
          target: { name: 'mainmenu' },
          canback: true,
          cannext: false
        })
        this.menuItems.push({
          label: 'a1-children',
          target: { name: 'a1' },
          canback: false,
          cannext: true
        })
      } else if (targetName === 'a1') {
        this.menuItems = []
        this.menuItems.push({
          label: 'back to a',
          target: { name: 'a' },
          canback: true,
          cannext: false
        })
        this.menuItems.push({
          label: 'a2-children',
          target: { name: 'a2' },
          canback: false,
          cannext: false
        })
      } else if (targetName === 'c') {
        this.menuItems = []
        this.menuItems.push({
          label: 'back to mainmenu',
          target: { name: 'mainmenu' },
          canback: true,
          cannext: false
        })
        this.menuItems.push({
          label: 'c1-children',
          target: { name: 'c1' },
          canback: false,
          cannext: true
        })
      } else if (targetName === 'c1') {
        this.menuItems = []
        this.menuItems.push({
          label: 'back to c',
          target: { name: 'c' },
          canback: true,
          cannext: false
        })
        this.menuItems.push({
          label: 'c2-children',
          target: { name: 'c2' },
          canback: false,
          cannext: false
        })
      }
    },
    // method 'GetPassport' use for get passport and set item to menuItems
    GetPassport () {
      // add code for get Passport here //

      this.InitializeMenuItems()
    },
    // method 'HideExtensionMenu'
    // work when your screen's width is less than 720, extension menu will hide and move to left menu
    HideExtensionMenu () {
      if (this.toggleAddMenu === false) {
        this.toggleAddMenu = true
      }
    },
    getPadding (itemLabel) {
      if (itemLabel == 'Refurbished Material') {
        return 'padding-left: 45px !important;'
      } else if (itemLabel == 'Disposal Material') {
        return 'padding-left: 40px !important;'
      }
      return ''
    }
  },
  watch: {
    '$store.getters.menuList': {
      handler () {
        this.menuExtension = [...this.$store.getters.menuList.filter(o => !o.hideMenu)]
      },
      deep: true
    }
  },
  computed: {
    authLoading () {
      return this.$store.getters.authLoading
    },
    globalLoading () {
      console.info('this.$store.getters => ', this.$store.getters)
      return this.$store.getters.loading
    },
    // depend on process.env.NODE_ENV you can check at '../../config'
    isColorRed () {
      const isENV = process.env.NODE_ENV
      if (isENV == 'production') {
        return false
      } else {
        return true
      }
    },
    // depend on process.env.NODE_ENV you can check at '../../config'
    HeaderEnv () {
      const isENV = process.env.NODE_ENV
      if (isENV == 'testing') {
        return 'Staging'
      } else if (isENV == 'development') {
        return 'Development'
      } else if (isENV == 'local') {
        return 'Local'
      } else {
        return ''
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss" scoped>
// default for mode_2
.navigation-drawer {
  background-color: #f3f4f8;
  top: 87px;
}

.list-tile-hover {
  &:hover {
    background-color: #686c67;
    // color: #fff;
    cursor: pointer;

    .list-tile-hover-icon {
      color: #fff;
    }
  }
}

.list-tile-hover-icon {
  color: rgba(0,0,0,.87);
}

.hr-line {
  margin: 10px;
  width: 94%;
  height: 2px;
  color: #ccc;
  background-color: #ccc;
  border: none;
}

.quick-links {
  color: #0b2d71;
  font-family: 'GothamBold';
  font-weight: 500;
}

.lbl-red {
  color: red!important;
}

.search-bar {
  width: 100vw;
  min-height: 100px;
  padding: 20px 30px;
  max-width: none;
}

.bg-offwhite {
  background-color: #f4f4f4 !important;
}

.font-gotham {
  font-family: 'GothamBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.dropdown-menu.show-xs {
  margin-top: 0;
  border: none;
  min-width: 160px;
  border-radius: 0;
  background-color: transparent;
  font-family: "GothamBook", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
}

.small-nav-container:after,
.small-nav-container:before {
  bottom: 100%;
  left:39px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.small-nav-container:after {
  border-bottom-color: #ededee;
  border-width: 16px;
  margin-left: -16px;
  position: absolute;
}

.small-nav-container {
  padding-bottom: 4px;
  background-color: #ededee;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.103);
  position: relative;
}

div.small-nav {
  text-align: left;
  margin-left: 0;
}

.small-nav h3 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 1.4em;
  padding-left: 30px;
  padding-top: 15px;
}

.small-nav li {
  margin: 0;
  padding: 0;
  font-size: 1.3em;
}

.icon-list li a:hover {
  background-color: #686c67;
  color: #fff!important;
}

.small-nav .icon-list li a {
  border: none;
  color: rgba(0,0,0,.87);;
  padding: 10px 30px;
  display: block;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

li.menu-hover > a {
  display: block;
  position: static;
  padding: 10px 20px;
  margin:0;
  border: none !important;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.header {
  &-container {
    height: 100px;

    ::v-deep .v-toolbar__content {
      background-color: #fff;
      height: 100px !important;
      flex: 1;
    }
  }

  &-toolbar-extension {
    background-color: #102f6c;
    width: 100%;
    height: 45px;

    &-btn {
      width: 160px;
      text-transform: uppercase !important;
    }
  }

  &-logo {
    height: 55px;

    &-image {
      width: 42px;
    }
  }

  &-sitename {
    font-family: 'GothamBold', Helvetica, Arial, sans-serif;
    font-size: 15px;
    font-weight: normal;
    line-height: 20px;
    color: #009dd9;
    text-decoration: none;
  }

  &-icon {
    &-btn {
      height: 70px;
    }
  }

  &-action {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: 'GothamBookMedium', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 12px;
    line-height: 14px;
    color: #0b2d71;

    .header-menu-icon {
      text-align: center;
      font-size: 40px;
      line-height: 24px;
    }
  }
}

// for mode_1 : when screen width less than 414
@media only screen and (max-width: 414px) {
  .hr-line {
    margin: 10px 30px;
    height: 2px;
    color: #ccc;
    background-color: #ccc;
    border: none;
  }

  .quick-links {
    color: #0b2d71;
    font-family: 'GothamBold';
    font-weight: 500;
  }

  .lbl-red {
    color: red!important;
  }

  .search-bar {
    width: 100vw;
    min-height: 100px;
    padding: 20px 30px;
    max-width: none;
  }

  .bg-offwhite {
    background-color: #f4f4f4 !important;
  }

  .font-gotham {
    font-family: 'GothamBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .header {
    &-container {
      height: 100px;

      ::v-deep .v-toolbar__content {
        background-color: #fff;
        height: 100px !important;
        flex: 1;
      }
    }

    &-toolbar-extension {
      background-color: #102f6c;
      width: 100%;
      height: 45px;

      &-btn {
        width: 160px;
      }
    }

    &-logo {
      height: 55px;

      &-image {
        width: 34px;
      }
    }

    &-sitename {
      font-family: 'GothamBold', Helvetica, Arial, sans-serif;
      font-size: 10px;
      font-weight: normal;
      line-height: 20px;
      color: #009dd9;
      text-decoration: none;
    }

    &-icon {
      &-btn {
        height: 70px;
      }
    }

    &-action {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-family: 'GothamBookMedium', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 12px;
      line-height: 14px;
      color: #0b2d71;

      .header-menu-icon {
        text-align: center;
        font-size: 30px;
        line-height: 24px;
      }
    }
  }
}
</style>
